(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/module-builder/component-registry/assets/prescript.js') >= 0) return;  svs.modules.push('/components/module-builder/component-registry/assets/prescript.js');

svs.components = svs.components || {};
svs.components.moduleBuilder = svs.components.moduleBuilder || {};
svs.components.moduleBuilder.componentRegistry = svs.components.moduleBuilder.componentRegistry || {};


 })(window);